import { useState, useMemo } from 'react'
import {
  Commission,
  UserRole,
  ProfileType,
  DateFilter,
} from '../types/commission'
import { MOCK_COMMISSIONS } from '../data/mockData'

const CURRENT_USER_ID = 'u1' // Katrina Bullock

export function useCommissionData(
  role: UserRole,
  searchQuery: string,
  selectedProfiles: ProfileType[],
  dateFilter: DateFilter,
) {
  // In a real app, this would fetch from an API
  const [data] = useState<Commission[]>(MOCK_COMMISSIONS)

  const filteredData = useMemo(() => {
    let result = [...data]

    // 1. Role-based visibility
    if (role === 'Loan Officer') {
      // Loan Officers only see themselves
      result = result.filter((item) => item.userId === CURRENT_USER_ID)
    } else {
      // Admins see everyone, but filter by search
      if (searchQuery) {
        const query = searchQuery.toLowerCase()
        result = result.filter(
          (item) =>
            item.userName.toLowerCase().includes(query) ||
            item.userProfile.toLowerCase().includes(query),
        )
      }

      // Admins can filter by profile type
      if (selectedProfiles.length > 0) {
        result = result.filter((item) =>
          selectedProfiles.includes(item.userProfile),
        )
      }
    }

    // 2. Date filtering (Simulated logic since mock data is all Dec 2025)
    // In a real app, we'd filter by item.loans[].date or payPeriod
    if (dateFilter !== 'All') {
      // For demo purposes, we're just returning everything if it matches the role rules
      // because our mock data is static for "December 2025"
      // Real implementation would compare dates here
    }

    return result
  }, [data, role, searchQuery, selectedProfiles, dateFilter])

  return filteredData
}
